module.exports = __webpack_public_path__ + "img/zgwc.e9b3b16d.png";